// hooks/useCampaign.ts
import { useQuery } from '@tanstack/react-query';
import { getCampaignDefaults } from 'api/campaign-defaults';
import httpClient from 'api/httpClient';
import { CampaignSettings } from 'models/CampaignSettings';

const fetchCampaignSettings = async (): Promise<CampaignSettings> => {
  const path = getCampaignDefaults();
  const { data } = await httpClient.get(path);

  return data;
};

const useCampaignSettings = () => {
  return useQuery({
    queryKey: ['campaign-defaults'],
    queryFn: () => fetchCampaignSettings(),
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes

    refetchOnWindowFocus: false, // Disable refetch on window focus
  });
};

export default useCampaignSettings;
